import PropTypes from "prop-types";

export const valuePropTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ])
};

export const validationPropTypes = {
  validation: PropTypes.shape({
    checkValidity: PropTypes.func,
    message: PropTypes.shape({
      default: PropTypes.string,
      required: PropTypes.string,
      pattern: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object
      ]),
      minlength: PropTypes.string,
      maxlength: PropTypes.string
    }),
    validateOn: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string)
    ]),
    validationRegex: PropTypes.regexp
  }).isRequired
};

export const withValidationInputDefaultProps = {
  classNames: ""
};

export const withValidationInputPropTypes = {
  classNames: PropTypes.string,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  ...valuePropTypes
};

export const withValidationOutputDefaultProps = {
  className: "",
  errorMessage: ""
};

export const withValidationOutputPropTypes = {
  className: PropTypes.string,
  context: PropTypes.object.isRequired,
  error: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string,
  handleBlur: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleValidation: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  ...validationPropTypes,
  validateOnRegisterUpdate: PropTypes.func.isRequired
};

export const sharedFormInputDefaultProps = {
  disabled: false,
  forceUpdate: false
};

export const sharedFormInputPropTypes = {
  disabled: PropTypes.bool,
  forceUpdate: PropTypes.bool,
  id: PropTypes.string,
};

export const checkboxAndRadioOptionsPropTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      disabled: PropTypes.bool,
      id: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired
};

export const optionsPropTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      disabled: PropTypes.bool,
      text: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired
};
